import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Buscar entre papeles qué trabajaste la sesión anterior',
    cost: 'Tiempo perdido + imagen desprofesionalizada'
  }, {
    without: 'Sin registro de evolución',
    cost: 'El paciente no ve su progreso y abandona el tratamiento'
  }, {
    without: 'Sin consentimiento informado',
    cost: 'Quedás expuesto legalmente ante cualquier reclamo'
  }, {
    without: 'Sin plan de tratamiento estructurado',
    cost: 'Cada sesión empieza de cero sin dirección real'
  }, {
    without: 'Sin control de stock',
    cost: 'Insumos que faltan en plena jornada'
  }, {
    without: 'Sin sistema de paquetes',
    cost: 'Ingresos irregulares e inestabilidad económica'
  }, {
    without: 'Sin checklist de apertura',
    cost: 'Improvisación que el paciente percibe y evalúa'
  }, {
    without: 'Sin tarjetas post-sesión',
    cost: 'El paciente se va sin guía y sin recordar tu profesionalismo'
  }, {
    without: 'Sin Acelerador de Consultorio',
    cost: 'Seguís esperando que el teléfono suene'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de caos, la semana que viene'
  }];
  return <Section data-id="element-19">
      <div className="text-center mb-12" data-id="element-20">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-21">
          <span className="mr-3" data-id="element-22">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-23">
        {/* Desktop: 2-column grid */}
        <div className="hidden md:block" data-id="element-24">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-25">
            <div className="font-serif font-bold text-lg text-brand-text/80" data-id="element-26">
              Sin REFLEXO-PRO
            </div>
            <div className="font-serif font-bold text-lg text-red-500" data-id="element-27">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-28">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-red-200 bg-white/60" data-id="element-29">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-30">
                  {row.without}
                </div>
                <div className="text-sm text-red-600/90 font-medium" data-id="element-31">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile: stacked cards */}
        <div className="md:hidden space-y-4" data-id="element-32">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-red-200 bg-white/60 space-y-2" data-id="element-33">
              <p className="text-sm font-medium text-brand-text/90" data-id="element-34">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-red-600/90 font-medium" data-id="element-35">
                <span className="text-red-500 shrink-0" data-id="element-36">→</span>
                <span className="text-sm" data-id="element-37">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-38">
        <p className="text-xl md:text-2xl font-serif italic text-[#1A1A1A]" data-id="element-39">
          "El terapeuta que registra, recuerda. El que recuerda, transforma. El
          que transforma, crece." 🦶
        </p>
      </div>
    </Section>;
};